import type { ChartUnit } from '../../../types/chart-unit.js';
import { Formatter, TimeFormatter } from '../../../types/formatter.js';
import type { Point } from '../../../types/point.js';
import { AnyScale } from '../../../types/scales.js';
import { isBandScale } from '../../../utils/detect-scale.js';
import { scaleBandInvert } from '../../../utils/scale.js';

export type MagnifierFormatter = Formatter | TimeFormatter;

function isDuration(args: {
  unit: ChartUnit;
  value: Date | number;
}): args is { unit: 'duration'; value: number } {
  return args.unit === 'duration';
}

export function getMagnifierLabel(
  unit: ChartUnit,
  coordinate: 'y' | 'x',
  formatter: MagnifierFormatter,
  mousePosition?: Point,
  scale?: AnyScale,
): string | undefined {
  if (!mousePosition || !scale) {
    return;
  }

  if (isBandScale(scale)) {
    return scaleBandInvert(scale)(mousePosition[coordinate]);
  }

  let value = scale.invert(mousePosition[coordinate]);

  const measurement = { unit, value };
  if (isDuration(measurement)) {
    value = Math.round(measurement.value);
  }

  return formatter(value as number & Date, unit);
}
